/**
 * Fired on window when tasks are added, changed or removed, so the
 * dashboard's open-task count and an open task list refresh.
 */
export const TASKS_CHANGED = "tadpole:tasks-changed";

export function announceTasksChanged() {
  window.dispatchEvent(new Event(TASKS_CHANGED));
}
